var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseTag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14507",
    "data-name": "Group 14507",
    transform: "translate(-1311.805 -115.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    transform: "translate(1311.805 115.805)",
    fill: "rgba(16,135,87,0.2)",
    stroke: "#ededed",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_24px",
    "data-name": "24px",
    transform: "translate(1314.483 118.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    "data-name": "Path 2566",
    d: "M0,0H10.643V10.643H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2567",
    "data-name": "Path 2567",
    d: "M11.208,5.625,10.583,5,8.1,7.479,5.625,5,5,5.625,7.479,8.1,5,10.583l.625.625L8.1,8.729l2.479,2.479.625-.625L8.729,8.1Z",
    transform: "translate(-2.783 -2.783)",
    fill: "#108757"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTag);
export default __webpack_public_path__ + "static/media/closeTag.5c13a79a42ef88f8e66e9679753d7d92.svg";
export { ForwardRef as ReactComponent };